import { Button, Pagination, Space, Table, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import React, { useState } from "react";
import { PaginationProps } from "antd/lib/pagination";
import { CONSTANT } from "../../../../config/Constant";
import { EditOutlined } from "@ant-design/icons";
import UpdateEmail from "./UpdateEmail";
import { checkPrivileges } from "../../../../config/Global";

interface DataType {
  index: number;
  row_id: number;
  provider_code: string;
  url: string;
  active: boolean;
  network_identity: number;
  network_type: string;
  provider_name: string;
  full_wsdl_address: string | null;
  custom_wsdl: boolean;
  email: string;
  created_date: string | any;
  _id: string;
}

const ListTable: React.FC<any> = (props) => {
  const {
    listData,
    setListData,
    totalData,
    tableloading,
    setTableLoading,
    paginationData,
    setPaginationData,
    getList,
    savePayload,
  } = props;

  const [openUpdateModal, setOpenUpdateModal] = useState<boolean>(false);
  const [openUpdateData, setOpenUpdateData] = useState<any>();

  const userDetails = localStorage.getItem("userDetails");
  const userRoles = userDetails && JSON.parse(userDetails)?.roles;

  const columns: ColumnsType<DataType> = [
    {
      title: "ID",
      dataIndex: "index",
      key: "index",
      width: 80,
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => a.index - b.index,
      render: (_, record) => {
        return record.index;
      },
    },
    {
      title: "Provider Id",
      dataIndex: "row_id",
      key: "row_id",
      width: 80,
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => a.row_id - b.row_id,
      render: (_, record) => {
        return record.row_id;
      },
    },
    {
      title: "Providers",
      key: "provider_code",
      dataIndex: "provider_code",
      width: 100,
      className: "text-center",
      fixed: "left",
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => a.provider_code.localeCompare(b.provider_code),
    },
    {
      title: "URL",
      key: "url",
      dataIndex: "url",
      width: 300,
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => (a.url || "").localeCompare(b.url || ""),
      render: (_, record) => {
        return (
          <div className="longData">{record.url ?? CONSTANT.NOT_UPDATED}</div>
        );
      },
    },
    {
      title: "Email",
      key: "email",
      dataIndex: "email",
      width: 300,
      sortDirections: ["descend", "ascend"],
      // sorter: (a, b) => a.email.localeCompare(b.email),
      sorter: (a, b) => (a.email || "").localeCompare(b.email || ""),
      render: (_, record) => {
        return (
          <div className="longData">{record.email ?? CONSTANT.NOT_UPDATED}</div>
        );
      },
    },
    {
      title: "Network Identity",
      key: "network_identity",
      dataIndex: "network_identity",
      width: 160,
      className: "text-center",
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => a.network_identity - b.network_identity,
    },
    {
      title: "Provider Name",
      key: "provider_name",
      dataIndex: "provider_name",
      width: 160,
      className: "text-center",
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) =>
        (a.provider_name || "").localeCompare(b.provider_name || ""),
    },
    {
      title: "Network Type",
      key: "network_type",
      dataIndex: "network_type",
      width: 140,
      className: "text-center",
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => a.network_type.localeCompare(b.network_type),
    },
    {
      title: "Created Date",
      dataIndex: "created_date",
      key: "created_date",
      width: 200,
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) =>
        a?.created_date?.toString().localeCompare(b?.created_date),
      render: (_, record) => {
        return record?.created_date
          ? record?.created_date
          : CONSTANT.NO_DATA_FOUND;
      },
    },
    {
      title: "Action",
      key: "action",
      width: 100,
      fixed: "right",
      hidden: checkPrivileges(userRoles, "admin") ? false : true,
      render: (_, record) => {
        return (
          <Space size="middle">
            <Tooltip title={"Edit Request"}>
              <Button
                type="default"
                icon={<EditOutlined />}
                className="EditBtn iconBtn"
                onClick={() => handleUpdateEmail(record)}
              />
            </Tooltip>
          </Space>
        );
      },
    },
  ];

  const providersData: DataType[] = listData?.map((item, index) => ({
    key: index.toString(),
    index: item.index,
    id: item.row_id,
    row_id: item.row_id,
    provider_code: item?.provider_code,
    url: item.url,
    active: item.active,
    network_identity: item.network_identity,
    network_type: item.network_type,
    provider_name: item.provider_name,
    full_wsdl_address: item.full_wsdl_address,
    custom_wsdl: item.custom_wsdl,
    email: item.email,
    created_date: item?.created_date,
  }));

  const handleChange: PaginationProps["onChange"] = (current, page_size) => {
    setListData([]);
    setTableLoading(true);
    setPaginationData({
      current: current,
      page_size: page_size,
    });
    const updateData = {
      ...savePayload,
      current: current,
      page_size: page_size,
    };
    getList(updateData);
  };

  const onShowSizeChange: PaginationProps["onShowSizeChange"] = (
    current,
    page_size
  ) => {
    setListData([]);
    setTableLoading(true);
    setPaginationData({
      current: current,
      page_size: page_size,
    });
    const updateData = {
      ...savePayload,
      current: current,
      page_size: page_size,
    };
    getList(updateData);
  };

  const handleUpdateEmail = (data: any) => {
    setOpenUpdateModal(!openUpdateModal);
    setOpenUpdateData(data);
  };
  return (
    <>
      <div className="responsiveTable">
        <Table
          dataSource={providersData}
          columns={columns}
          pagination={false}
          loading={tableloading}
        />
        <div className="text-center mt-20 mb-30">
          <Pagination
            defaultCurrent={1}
            current={paginationData?.current}
            total={totalData ?? 0}
            onChange={handleChange}
            responsive={true}
            pageSize={paginationData?.page_size}
            // showSizeChanger={totalData ? true : false}
            showSizeChanger
            onShowSizeChange={onShowSizeChange}
            pageSizeOptions={CONSTANT.PER_PAGE_RECORD}
          />
        </div>
      </div>

      <UpdateEmail
        openUpdateModal={openUpdateModal}
        handleUpdateEmail={handleUpdateEmail}
        openUpdateData={openUpdateData}
        getList={getList}
      />
    </>
  );
};
export default ListTable;
